import { render, staticRenderFns } from "./RefundStat.vue?vue&type=template&id=2b1374ec&scoped=true"
import script from "./RefundStat.vue?vue&type=script&lang=js"
export * from "./RefundStat.vue?vue&type=script&lang=js"
import style0 from "./RefundStat.vue?vue&type=style&index=0&id=2b1374ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1374ec",
  null
  
)

export default component.exports